/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Link, Switch, Redirect } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { ContentRoute } from "../../../../_metronic/layout";
import Login from "./Login";
import Registration from "./Registration";
import ForgotPassword from "./ForgotPassword";
import "../../../../_metronic/_assets/sass/pages/login/classic/login-1.scss";
import { ResetPassword } from "./ResetPassword";
import { PrivacyPolicy } from "./PrivacyPolice";
import { showErrorDialog, year } from "../../../utility";
import { downloadApk, fetchVersion } from "../../../pages/user/userSlice";
import { useDispatch } from "react-redux";

export function AuthPage() {
  const dispatch = useDispatch();

  const handleDownload = async () => {
    try {
      const response = await dispatch(fetchVersion());
      if (response.payload.data.status_code === 200) {
        const version = response.payload.data.data;

        try {
          const response = await dispatch(
            downloadApk({
              apk_version: version,
            })
          );
          if (response.payload.data.status_code === 200) {
            const apk = response.payload.data.data.apk_path;

            window.open(apk);
          } else {
            showErrorDialog(response.payload.data.message);
          }
        } catch (error) {
          showErrorDialog(error.message);
        }
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  return (
    <>
      <div className="d-flex flex-column flex-root">
        {/*begin::Login*/}
        <div
          className="login login-1 login-signin-on d-flex flex-column flex-lg-row flex-column-fluid bg-white"
          id="kt_login"
        >
          {/*begin::Aside*/}
          <div className="login-aside d-flex flex-row-auto bgi-size-cover bgi-no-repeat p-10 p-lg-10">
            {/*begin: Aside Container*/}
            <div className="d-flex flex-row-fluid flex-column justify-content-between">
              {/* end:: Aside header */}

              {/* start:: Aside content */}
              <div className="flex-column-fluid d-flex flex-column justify-content-center">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    // height: "100vh",
                  }}
                >
                  <img
                    alt="Logo"
                    src={toAbsoluteUrl("/media/logos/Brand.png")}
                    style={{ width: "75%" }}
                  />
                </div>
              </div>
              {/* end:: Aside content */}

              {/* start:: Aside footer for desktop */}
              <div className="d-none flex-column-auto d-lg-flex justify-content-between mt-10">
                <div className="opacity-70 font-weight-bold	text-dark-75">
                  &copy; {year} Pivore
                </div>
                <div className="d-flex">
                  <Link
                    to="/privacy-policy"
                    className="text-dark-75 text-hover-primary"
                  >
                    Privacy
                  </Link>

                  <Link to="/terms" className="text-dark-75 ml-10">
                    Legal
                  </Link>
                  <p
                    className="text-dark-75 ml-10"
                    style={{ cursor: "pointer" }}
                    onClick={() => handleDownload()}
                  >
                    Download
                  </p>
                </div>
              </div>
              {/* end:: Aside footer for desktop */}
            </div>
            {/*end: Aside Container*/}
          </div>
          {/*begin::Aside*/}

          {/*begin::Content*/}
          <div
            className="d-flex flex-column flex-row-fluid position-relative p-7 overflow-hidden"
            style={{
              background:
                "linear-gradient(34.62deg, #FF3333 -9.16%, #DD3434 109.96%)",

              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
            }}
          >
            {/* begin::Content body */}
            <div className="d-flex flex-column-fluid flex-center mt-30 mt-lg-0">
              <Switch>
                <ContentRoute path="/auth/login" component={Login} />
                <ContentRoute
                  path="/auth/reset-password"
                  component={ResetPassword}
                />

                {/* Moved outside /auth */}
                <Redirect from="/auth" exact={true} to="/auth/login" />
                <Redirect to="/auth/login" />
              </Switch>
            </div>
            {/*end::Content body*/}

            {/* begin::Mobile footer */}
            <div className="d-flex d-lg-none flex-column-auto flex-column flex-sm-row justify-content-between align-items-center mt-5 p-5">
              <div className="text-white font-weight-bold order-2 order-sm-1 my-2">
                &copy; {year} Pivore
              </div>
              <div className="d-flex order-1 order-sm-2 my-2">
                <Link
                  to="/privacy-policy"
                  className="text-white text-hover-primary"
                >
                  Privacy
                </Link>

                <Link
                  to="/terms"
                  className="text-white text-hover-primary ml-4"
                >
                  Legal
                </Link>
                <p
                  className="text-white text-hover-primary ml-4"
                  onClick={() => handleDownload()}
                >
                  Download
                </p>
              </div>
            </div>
            {/* end::Mobile footer */}
          </div>
          {/*end::Content*/}
        </div>
        {/*end::Login*/}
      </div>
    </>
  );
}
